import { AiOutlineWechatWork } from "react-icons/ai";
import styles from './ChatIconStyle.module.css';
import React from "react";

type Props = {
  className?: string
} & React.ComponentProps<'div'>

const ChatIcon = ({ className, ...props }: Props) => {
  return (
    <div className={className ?? styles.background} title="Ask AI" {...props}>
      <AiOutlineWechatWork size="25" />
    </div>
  )
}

export default ChatIcon
